/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_ROOT_FACADE = '/availability';
const RESOURCE_PAGE_FACADE = '/greetingcard';

const getGreetingAvailability = (wcEnv, jwtToken, productCode, brandCode, zipCode, locationType, deliveryDate) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;
    const resourcePage = RESOURCE_PAGE_FACADE;

    const params = {
        productCode,
        brandCode,
        zipCode,
        locationType,
        deliveryDate,
    };

    return restClient.getFacade(env, resourcePage, jwtToken, params)
        .then((response) => response);
};

export default getGreetingAvailability;
